import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable()
export class GuidedTourService {
  private filterStepTrigger = new Subject<void>();
  filterStepTrigger$ = this.filterStepTrigger.asObservable();

  private filterStepTriggerOff = new Subject<void>();
  filterStepTriggerOff$ = this.filterStepTriggerOff.asObservable();

  private restartTour = new Subject<void>();
  restartTour$ = this.restartTour.asObservable();

  constructor() {}

  startTour = new BehaviorSubject<boolean>(false);

  currentStep = new BehaviorSubject<number>(-1);

  setStartTour(value) {
    if (value) {
      // if the value is true, set step as '1'.
      this.setCurrentStep(0);
    }
    this.startTour.next(value);
  }

  setCurrentStep(value) {
    this.currentStep.next(value);
  }

  triggerFilterStep() {
    console.log("TOGGLING FILTER STEP");
    this.filterStepTrigger.next();
  }

  triggerFilterStepOff() {
    console.log("TOGGLING FILTER STEP");
    this.filterStepTriggerOff.next();
  }

  triggerTourRestart() {
    this.restartTour.next();
  }
}
